import { Availability } from '../types/availability';

/** Maps ISO date strings ("YYYY-MM-DD") to the Availability period that covers that day. */
export type AvailabilityMap = ReadonlyMap<string, Availability>;

/**
 * Build a day-by-day map from a list of availability periods.
 *
 * - Each period is expanded day-by-day from `startDate` to `endDate` inclusive.
 * - If periods overlap on a day, the last writer wins (caller should sort by startDate ASC
 *   before calling so that later-startDate periods overwrite earlier ones on shared days).
 *
 * @param periods - Array of availability periods (sorted by startDate ASC by the caller).
 */
export const buildAvailabilityMap = (periods: readonly Availability[]): AvailabilityMap => {
  const map = new Map<string, Availability>();

  for (const period of periods) {
    const [sy, sm, sd] = period.startDate.split('-').map(Number);
    const [ey, em, ed] = period.endDate.split('-').map(Number);

    const start = new Date(sy, sm - 1, sd);
    const end = new Date(ey, em - 1, ed);

    const cursor = new Date(start);
    while (cursor <= end) {
      const y = cursor.getFullYear();
      const m = String(cursor.getMonth() + 1).padStart(2, '0');
      const d = String(cursor.getDate()).padStart(2, '0');
      map.set(`${y}-${m}-${d}`, period);
      cursor.setDate(cursor.getDate() + 1);
    }
  }

  return map;
};
